import { type FC } from 'react';

import LockPin from '@/assets/icons/lock-pin.svg?react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface LockPinButtonProps {
  isLocked: boolean;
  onClick: () => void;
  className?: string;
}

const LockPinButton: FC<LockPinButtonProps> = ({ isLocked, onClick, className }) => {
  return (
    <Button
      onClick={onClick}
      variant={isLocked ? 'default' : 'outline'}
      className="flex items-center justify-center size-9 rounded-lg"
      aria-label={isLocked ? 'Unlock pin' : 'Lock pin'}
    >
      <LockPin className={cn('size-5', { 'fill-white': isLocked }, className)} aria-hidden />
    </Button>
  );
};

export default LockPinButton;
